module.exports = __webpack_public_path__ + "media/images/case_studies/moet_hennessy/hero-63177fa84ed65a6a7cb2f3689a2f871f.svg";